import { createFileRoute } from "@tanstack/react-router";

import { DailyCommissionsPage } from "@/modules/commissions/pages/DailyCommissions.page";

export const Route = createFileRoute("/__authed/m/commissions/daily")({
	component: DailyCommissionsPage,
});
